import React from "react";
import { Box } from "@twilio-paste/core/box";
import { Text, Button } from "@twilio-paste/core";
import { useSelector } from "react-redux";

import { Header } from "../Header";
import { NotificationBar } from "../NotificationBar";
import { titleStyles, boxStyles, actionBoxStyles } from "../styles/ThankYouPhase.styles";
import { useStartNewChat } from "../../hooks/useStartNewChat";
import { AppState } from "../../store/definitions";

export const ThankYouPhase = () => {
    const autoInitiConfig = useSelector((state: AppState) => state.config.autoInitConfig);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const startNewChat = useStartNewChat();

    const handleRestartChat = () => {
        setIsLoading(true);
        startNewChat();
    };

    const renderButton = () => {
        if (autoInitiConfig === undefined) {
            return (
                <Box data-testid="action-box" {...actionBoxStyles}>
                    <Button
                        variant="primary"
                        data-testid="post-chat-survey-start-new-chat"
                        loading={isLoading}
                        onClick={handleRestartChat}
                    >
                        Chat again
                    </Button>
                </Box>
            );
        }

        return null;
    };

    return (
        <>
            <Header customTitle="Thank You" />
            <NotificationBar />
            <Box data-testid="thank-you-box" {...boxStyles}>
                <Text {...titleStyles} as="h3">
                    Thank you for contacting us
                </Text>
                {renderButton()}
            </Box>
        </>
    );
};
